import { ICandidateLocationFilter } from "@core/models";

export const locationMock = [
  {
    [ICandidateLocationFilter.zipcode]: "75011",
    [ICandidateLocationFilter.city]: "Paris 11",
    [ICandidateLocationFilter.department]: "Ile-de-France",
  },
  {
    [ICandidateLocationFilter.zipcode]: "92100",
    [ICandidateLocationFilter.city]: "Boulogne-Billancourt",
    [ICandidateLocationFilter.department]: "Ile-de-France",
  },
  {
    [ICandidateLocationFilter.zipcode]: "37540",
    [ICandidateLocationFilter.city]: "Saint-Cyr-sur-Loire",
    [ICandidateLocationFilter.department]: "Indre-et-Loire",
  },
];
